export const zcGetters = {

    orderStatusList:state => state.zc.orderStatusList,
    productList:state => state.zc.productList,
    planStatusList:state => state.zc.planStatusList,
    clientDictList:state => state.zc.clientDictList,
    agentDictList:state => state.zc.agentDictList,
    serviceTypeList:state => state.zc.serviceTypeList,
    trainTypeList:state => state.zc.trainTypeList,
    segList:state => state.zc.segList,
    provideList:state => state.zc.provideList,
    renewList:state => state.zc.renewList,

    orderList:state => state.zc.orderList,
    planList:state => state.zc.planList,
    importOrderExcel:state => state.zc.importOrderExcel,
    planList_ByCate:state => state.zc.planList_ByCate,

    clientList:state => state.zc.clientList,
    agentList:state => state.zc.agentList,
    clientOrderList:state => state.zc.clientOrderList,


    resultList:state => state.zc.resultList,

    trainList:state => state.zc.trainList,

    
    indexStatValueList:state=>{
        // console.log('aaa')
        const indexStatValueList = state.zc.ZC_Index[0] ?? [];
        return indexStatValueList;
    },
    indexUrgentList:state=>{
        const indexUrgentList = state.zc.ZC_Index[1] ?? [];
        return indexUrgentList;
    },
    weekDoneList:state=>{
        const weekDoneList = state.zc.ZC_Index[2] ?? [];
        return weekDoneList;
    },
    analisysCate1:state=>{
        const ana = state.zc.ZC_Index[3] ?? [];
        return ana;
    },
    analisysCate2:state=>{
        const ana = state.zc.ZC_Index[4] ?? [];
        return ana;
    },
    analisysCall:state=>{
        const ana = state.zc.ZC_Index[5] ?? [];
        return ana;
    },

    alertList:state => state.zc.alertList,
};